import { Box } from "@chakra-ui/react";
import React from "react";

import Hover from "../signup/Hover";

const Hamburger = () => {
  return (
    <Box>
      <Hover />
    </Box>
  );
};

export default Hamburger;
